// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_Pzs","cls2":"ArticlesFilters-cls2_IS9 ArticlesFilters-cls1_Pzs"};